export enum AdminAuditEventType {
    PASSWORD_POLICY_CHANGED = 'Password Policy Changed',
    EMAIL_DOMAIN_CHANGED = 'Email Domain Changed',
    MFA_POLICY_CHANGED = 'Multifactor Authentication Policy Changed',
    MFA_IP_ADDRESS_ADDED = 'Multifactor Authentication IP Address Added',
    MFA_IP_ADDRESS_REMOVED = 'Multifactor Authentication IP Address Removed',
    MFA_IP_ADDRESSES_IMPORTED = 'Multifactor Authentication IP Addresses Imported',
    MFA_CREDENTIAL_REMOVED = 'Multifactor Authentication Credential Removed',
    UID_ACCOUNT_CREATED = 'Universal ID Account Created',
    UID_ACCOUNT_UPDATED = 'Universal ID Account Updated',
    UID_ACCOUNT_LINKED = 'Universal ID Account Linked',
    UID_ACCOUNT_UNLINKED = 'Universal ID Account Unlinked',
    INSTANCES_STATUS_CHANGED = 'Instances Status Changed',
    ENTERPRISE_ADMIN_ROLE_ADDED = 'Enterprise Admin Role Added',
    ENTERPRISE_ADMIN_ROLE_REMOVED = 'Enterprise Admin Role Removed',
    ENTERPRISE_PREFERENCES_CHANGED = 'Enterprise Preferences Policy Changed',
    AUDIT_REPORT_CREATED = 'Audit Report Created',
    AUDIT_REPORT_UPDATED = 'Audit Report Changed',
    BULK_MATCH_SSO_USERS = 'Bulk Match & Create Universal IDs',
    PASSWORD_RESET = 'Password Reset',
    ACCESS_ROLE_GRANTED = 'Access Role Granted',
    ACCESS_ROLE_UPDATED = 'Access Role Updated',
    ACCESS_ROLE_REVOKED = 'Access Role Revoked',
    INACTIVITY_TIMEOUT_CHANGED = 'Inactivity Timeout Policy Changed'
}
